module.exports = __webpack_public_path__ + "friend5.png?8c5008fe31876d3453c02d7765b5e853";


//////////////////
// WEBPACK FOOTER
// ./static/assets/friend5.png
// module id = 478
// module chunks = 0